import { Utils, Range, Ticker } from "@progress/kendo-diagram-common";

(function() {
    var kendo = window.kendo,
        diagram = kendo.dataviz.diagram = {};

    kendo.deepExtend(diagram, {
        init: function(element) {
            kendo.init(element, diagram.ui);
        },

        Utils: Utils,
        Range: Range,
        Ticker: Ticker
    });
})();
